import { useRef, useEffect, useState } from 'react';
import 'mapbox-gl/dist/mapbox-gl.css';
import './customMapBox.css';
import mapboxgl from '!mapbox-gl';  // eslint-disable-line import/no-webpack-loader-syntax
import markerImage from "@public/img/navigation-marker.png";
import markerImageRed from "@public/img/navigation-marker-red.png";
import markerImageGrey from "@public/img/navigation-marker-grey.png";


mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_TOKEN; // TODO: this sensitive variable should be retreived from the backend rather than published in the build.

const defaultInitialCoordinates = [7.14733, 46.7968]; // starting position [lng, lat]
const defaultMapZoom = 15;
const defaultVehicleId = 'default';

const emergencyHz = 2 ;
let emergencyColor = 0;

setInterval(emergencyBlink, 1000/emergencyHz);
function emergencyBlink() {
    if (emergencyColor){
        emergencyColor = 0
    } else {
        emergencyColor = 1
    }
}

function createVehicleMarker(vehicle) {
    const popup = new mapboxgl.Popup({ offset: 25, className: 'map-popup' });
    popup.setHTML('<h4>'+ vehicle.id + '</h4>');

    const img = document.createElement('img');
    img.className = 'marker';
    img.src = markerImage;
    img.height = 30;

    switch (vehicle.state){
        case 'emergency':
            if(emergencyColor)
                img.style.filter = `invert(77%) sepia(59%) saturate(6803%) hue-rotate(359deg) brightness(100%) contrast(107%)` //Orange
            else
                img.style.filter = `invert(44%) sepia(91%) saturate(5612%) hue-rotate(344deg) brightness(92%) contrast(94%)` //Red
            break;
        case 'driving':
            img.style.filter = ` invert(32%) sepia(82%) saturate(2147%) hue-rotate(211deg) brightness(103%) contrast(96%)` //Blue
            break;
        case 'autonomous':
            img.style.filter = `invert(74%) sepia(27%) saturate(919%) hue-rotate(118deg) brightness(99%) contrast(92%)` //Turquoise
            break;
        case 'docking': 
            img.style.filter = `invert(66%) sepia(33%) saturate(7205%) hue-rotate(105deg) brightness(97%) contrast(89%)` //Green
            break;
        case 'parking': 
            img.src = markerImage // Black
            break;
        case 'maintenance': // Yellow
            img.src = markerImage
            img.style.filter = `invert(83%) sepia(70%) saturate(912%) hue-rotate(323deg) brightness(98%) contrast(110%)`
            break;
        default :
            img.src = markerImage;
            break;
    }

    const coordinates = [vehicle.localization.longitude, vehicle.localization.latitude];
    const marker = new mapboxgl.Marker(img);
    marker.setLngLat(coordinates);
    marker.setPopup(popup);
    marker.setRotationAlignment('map');
    marker.setRotation(vehicle.localization.heading);

    return marker;
}

export default function useMap(vehicles, initialCoordinates=defaultInitialCoordinates, mapZoom=defaultMapZoom, currentVehicleId=defaultVehicleId) {
    const mapRef = useRef(null);
    const mapContainerRef = useRef(null);
    const [mapCenter, setMapCenter] = useState(initialCoordinates);
    const [vehicleCoordinates, setVehicleCoordinates] = useState(initialCoordinates);

    useEffect(() => {
        console.log('Loading map...');
        mapRef.current = new mapboxgl.Map({
          container: mapContainerRef.current,
          style: 'mapbox://styles/mapbox/traffic-day-v2',
          center: mapCenter,
          zoom: mapZoom,
        });
    
        return () => mapRef.current.remove();
      }, [mapCenter, mapZoom]);

    useEffect(() => {
        const markers = new Map();
    
        vehicles.forEach((vehicle) => {
          if(vehicle.localization) {
            const marker = createVehicleMarker(vehicle);
            marker.addTo(mapRef.current);
            markers.set(vehicle.id, marker);

            if (vehicle.id === currentVehicleId) {
                setVehicleCoordinates([vehicle.localization.longitude, vehicle.localization.latitude]);
            }
          }
        });
        
        return () => {
          markers.forEach((marker) => {
            marker.remove();
          });
        };
      }, [vehicles]);

    const updateMapCenter = (coordinates) => {
        setMapCenter(coordinates);
    };

    useEffect(() => {
        // Update map center to follow the vehicle
        if (mapRef.current && vehicleCoordinates) {
            mapRef.current.setCenter(vehicleCoordinates);
        }
    }, [vehicleCoordinates]);

    return { mapRef, mapContainerRef};
};
